import React, { useState, useEffect } from 'react';
import { fmt, api } from '../utils/api';

export default function TopTickers({ refreshKey }) {
  const [quotes, setQuotes] = useState(null);
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    api.getTickers().then((data) => setQuotes(data.quotes || [])).catch(() => setQuotes([]));
  }, [refreshKey]);

  if (!quotes) return null;

  const available = quotes.filter((q) => q.available && q.showOnOverview);
  if (available.length === 0) return null;

  const top5 = [...available]
    .sort((a, b) => Math.abs(b.changePct) - Math.abs(a.changePct))
    .slice(0, 5);

  return (
    <div style={styles.panel}>
      <button style={styles.titleBtn} onClick={() => setCollapsed((c) => !c)}>
        <span style={styles.chevron}>{collapsed ? '▸' : '▾'}</span>
        <h2 style={{ ...styles.title, margin: 0 }}>📊 Tickers you follow</h2>
      </button>
      {!collapsed && (
      <div style={styles.list}>
        {top5.map((q) => {
          const up = q.changePct >= 0;
          const color = up ? '#00d4aa' : '#ef4444';
          return (
            <div key={q.ticker} style={styles.row}>
              <span style={styles.ticker}>{q.ticker}</span>
              <span style={styles.price}>{fmt.currency(q.price)}</span>
              <span style={{ ...styles.change, color }}>
                {up ? '▲' : '▼'} {Math.abs(q.changePct).toFixed(2)}%
              </span>
            </div>
          );
        })}
      </div>
      )}
    </div>
  );
}

const styles = {
  panel: {
    background: '#111827',
    border: '1px solid #1e2a3a',
    borderRadius: '16px',
    padding: '1.25rem',
  },
  titleBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    marginBottom: '0.75rem',
  },
  chevron: { color: '#6b7280', fontSize: '0.75rem' },
  title: {
    margin: '0 0 0.75rem',
    fontSize: '0.9rem',
    fontWeight: '700',
    color: '#fff',
    fontFamily: "'Syne', sans-serif",
  },
  list: { display: 'flex', flexDirection: 'column', gap: '0.35rem' },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '4px 0',
  },
  ticker: {
    color: '#e5e7eb',
    fontSize: '0.78rem',
    fontWeight: '700',
    fontFamily: "'Syne', sans-serif",
    minWidth: '50px',
  },
  price: {
    color: '#6b7280',
    fontSize: '0.75rem',
    fontFamily: "'DM Mono', monospace",
    flex: 1,
  },
  change: {
    fontSize: '0.75rem',
    fontWeight: '700',
    fontFamily: "'DM Mono', monospace",
  },
};
